import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=6e0f856a&scoped=true&"
import script from "./OffersTable.vue?vue&type=script&lang=js&"
export * from "./OffersTable.vue?vue&type=script&lang=js&"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=6e0f856a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f856a",
  null
  
)

export default component.exports